<div class="content-wrapper container-xxl p-0" *ngIf="!showRechazar && !showMotivo">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section class="invoice-list-wrapper">
            <div class="card">
                <div class="row">
                    <div class="col-md-3 col-12">
                        <div class="d-flex justify-content-between align-items-center m-1">
                            <div class="d-flex align-items-center">
                                <label class="d-flex align-items-center">Ver&nbsp;
                                    <select class="form-control mx-20" [(ngModel)]="selectedOption" (ngModelChange)="changePageSize($event)">
                                        <option *ngFor="let opt of limitOptions" [ngValue]="opt.value">{{opt.key}}
                                        </option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-12"></div>
                    <div class="col-md-6 col-12 d-flex justify-content-start justify-content-md-end align-items-center">
                        <div class="row pb-md-0 align-items-center w-100">
                            <div class="col-sm-12 col-md-6 pr-0">
                                <label class="d-flex align-items-center mb-0 ml-1 ml-md-0">
                                    <input [(ngModel)]="searchValue" name="searchValue" type="search" class="form-control" placeholder="Búsqueda" (keyup)="filterAll()"/>
                                </label>
                            </div>
                            <div class="col-sm-12 col-md-6 ml-md-0 my-sm-1 ml-sm-1 my-1 ml-1 mr-0 pr-0 pr-sm-1">
                                <fieldset class="form-group mb-0 mr-sm-0 mr-md-1 mr-0 pr-0">
                                    <ng-select
                                      [items]="selectStatus"
                                      [(ngModel)]="selectedStatus"
                                      bindLabel="name"
                                      placeholder="Seleccione estado"
                                      (change)="filterAll()"
                                    ></ng-select>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
                <ngx-datatable #table [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="selectedOption"
                [columnMode]="ColumnMode.force" [headerHeight]="120" [footerHeight]="50" [scrollbarH]="true" [messages]="{emptyMessage: ''}" >
                    <ngx-datatable-column name="Resetear Evaluaciones" [sortable]="true" [width]="230"> 
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button class="btn btn-sm btn-danger" (click)="resetarEvaluacion(row.ID_evaluado, row.ID_evaluador, row.nombreEvaluado)" title="Resetear esta Evaluacioón" *ngIf="row.estadoEvaluacion == 'Finalizado'">
                                Resetear
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Evaluado" prop="nombreEvaluado" [width]="400">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="d-flex">
                                <div class="avatar mr-75">
                                    <img src="{{urlImage}}{{row.ID_evaluado}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                        class="" width="42" height="42" data-placement="left"/>
                                </div>
                                <div class="columnNomEvaluado">
                                    {{row?.nombreEvaluado}}
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Relación" prop="relacionEvaluador" [width]="200">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="badge badge-glow badge-secondary">
                                {{row?.relacionEvaluador === 'CLIENTE' ? 'OBSERVADOR' : (row?.relacionEvaluador | uppercase) }}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Evaluador" prop="nombreEvaluador" [width]="400">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="d-flex">
                                <div class="avatar mr-75">
                                    <img src="{{urlImage}}{{row.ID_evaluador}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                        class="" width="42" height="42" data-placement="left"/>
                                </div>
                                <div class="columnNomEvaluador">
                                    {{row?.nombreEvaluador}}
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Estado" prop="aprobacion" [width]="140">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="badge badge-glow" [ngClass]="{'badge-success': row.aprobacion == 'Aprobado', 'badge-danger': row.aprobacion == 'Rechazado'}">
                                {{row?.aprobacion }}
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Revisor" prop="revisor" [width]="400">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="d-flex" *ngIf="row.aprobacion === 'Rechazado'">
                                <div class="avatar mr-75">
                                    <img src="{{urlImage}}{{row.ID_revisor}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                        class="" width="42" height="42" data-placement="left"/>
                                </div>
                                <div class="columnRevisor">
                                    {{row?.revisor}}
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Rol" prop="rolRevisor" [width]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row?.rolRevisor}}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Acción" [sortable]="false"> 
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button class="btn btn-sm btn-danger" (click)="changeShowRechazar(row)" *ngIf="row.aprobacion === 'Aprobado'">
                                Rechazar
                            </button>
                            <button class="btn btn-sm btn-primary px-2" (click)="changeShowMotivo(row)" *ngIf="row.aprobacion === 'Rechazado'">
                                Motivo
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                          let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
                          <div style="padding: 5px 10px" *ngIf="rowCount > 0 ">
                            Total de registros {{rowCount}}
                          </div>                         
                          <div style="padding: 5px 10px" *ngIf="rowCount == 0 && isLoadingPage">
                            Cargando información...
                          </div>
                          <div style="padding: 5px 10px" *ngIf="rows.length == 0 && !isLoadingPage">
                            No hay evaluados ...
                          </div>
                          <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
                            [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
                            [pagerNextIcon]="'datatable-icon-skip'" [count]="rowCount" [page]="curPage" [size]="pageSize"
                            (change)="onChange($event)" [hidden]="!((rowCount / pageSize) > 1)">
                          </datatable-pager>
                        </ng-template>
                    </ngx-datatable-footer>
                </ngx-datatable>
            </div>
        </section>
    </div>
</div>

<!-- Inicio Rechazar -->
<div *ngIf="showRechazar">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-7">
            <h1 class="mt-2 mb-4 text-center">Rechazar evaluación</h1>
            <div class="card">
                <div class="card-body">
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mr-2">
                            <h6 class="m-0 pr-1">EVALUADO</h6>
                        </div>
                        <div class="media d-flex align-items-center">
                            <div class="avatar mr-75">
                                <img src="{{urlImage}}{{evaluacionRechazar.ID_evaluado}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                                    class="" width="42" height="42" data-placement="left"/>
                            </div>
                            <div class="media-body my-auto">
                                <h6 class="mb-0">{{evaluacionRechazar.nombreEvaluado}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mr-2">
                            <h6 class="m-0">EVALUADOR</h6>
                        </div>
                        <div class="media d-flex align-items-center">
                            <div class="avatar mr-75">
                                <img src="{{urlImage}}{{evaluacionRechazar.ID_evaluador}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                                    class="" width="42" height="42" data-placement="left"/>
                            </div>
                            <div class="media-body my-auto">
                                <h6 class="mb-0">{{evaluacionRechazar.nombreEvaluador}}</h6>
                            </div>
                        </div>
                    </div>

                    <form [formGroup]="formRechazar">
                        <label for="textAreaMotivo">Motivo</label>
                        <fieldset class="form-group">
                            <textarea class="motivo form-control" formControlName="motivo" id="textAreaMotivo" rows="3"
                                placeholder="En este campo explica el motivo por el cual rechaza la evaluación"
                                [ngClass]="{'is-invalid': ((formRechazar.get('motivo').touched || formRechazar.get('motivo').dirty) && formRechazar.get('motivo').errors)}"></textarea>
                            <div *ngIf="formRechazar.get('motivo').hasError('required') && (formRechazar.get('motivo').dirty || formRechazar.get('motivo').touched)"
                                class="invalid-feedback">
                                El motivo es obligatorio
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <button class="btn btn-warning" [disabled]="!formRechazar.valid" (click)="rechazarEvaluacion()" *ngIf="!rechazando">
                Rechazar
            </button>
            <button class="btn btn-warning" type="button" disabled rippleEffect *ngIf="rechazando">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="ml-25 align-middle">Rechazando...</span>
            </button>
            <button class="btn btn-danger mx-1" (click)="cancelShowRechazar()">Cancelar</button>
        </div>
    </div>
</div>
<!-- Fin Rechazar -->

<!-- Inicio Motivo -->
<div *ngIf="!showRechazar && showMotivo">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-7">
            <h1 class="mt-2 mb-4 text-center">Evaluación inhabilitada</h1>
            <div class="card">
                <div class="card-body">
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mr-3">
                            <h6 class="m-0 pr-1">EVALUADO</h6>
                        </div>
                        <div class="media d-flex align-items-center">
                            <div class="avatar mr-75">
                                <img src="{{urlImage}}{{evaluacionMotivo.ID_evaluado}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                                    class="" width="42" height="42" data-placement="left"/>
                            </div>
                            <div class="media-body my-auto">
                                <h6 class="mb-0">{{evaluacionMotivo.nombreEvaluado}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mr-3">
                            <h6 class="m-0">EVALUADOR</h6>
                        </div>
                        <div class="media d-flex align-items-center">
                            <div class="avatar mr-75">
                                <img src="{{urlImage}}{{evaluacionMotivo.ID_evaluador}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                                    class="" width="42" height="42" data-placement="left"/>
                            </div>
                            <div class="media-body my-auto">
                                <h6 class="mb-0">{{evaluacionMotivo.nombreEvaluador}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex mb-2">
                        <div class="d-flex align-items-center mr-2">
                            <h6 class="m-0">INHABILITADOR</h6>
                        </div>
                        <div class="media d-flex align-items-center">
                            <div class="avatar mr-75">
                                <img src="{{urlImage}}{{evaluacionMotivo.ID_revisor}}.jpg" onerror="this.onerror=null;this.src='assets/images/avatars/evaluador.png'"
                                                    class="" width="42" height="42" data-placement="left"/>
                            </div>
                            <div class="media-body my-auto">
                                <h6 class="mb-0">{{evaluacionMotivo.revisor}}</h6>
                            </div>
                        </div>
                    </div>
                    <form [formGroup]="formMotivo">
                        <label for="textAreaMotivo">Motivo</label>
                        <fieldset class="form-group">
                            <textarea class="motivo form-control" disabled formControlName="motivo" id="textAreaMotivo" rows="3"
                                [ngClass]="{'is-invalid': ((formMotivo.get('motivo').touched || formMotivo.get('motivo').dirty) && formMotivo.get('motivo').errors)}"></textarea>
                            <div *ngIf="formMotivo.get('motivo').hasError('required') && (formMotivo.get('motivo').dirty || formMotivo.get('motivo').touched)"
                                class="invalid-feedback">
                                El motivo es obligatorio
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
            <button class="btn btn-warning" [disabled]="!formMotivo.valid" (click)="activarEvaluacion()" *ngIf="!activando">
                Activar
            </button>
            <button class="btn btn-warning" type="button" disabled rippleEffect *ngIf="activando">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="ml-25 align-middle">Activando...</span>
            </button>
            <button class="btn btn-danger mx-1" (click)="cancelShowMotivo()">Cancelar</button>
        </div>
    </div>
</div>
<!-- Fin Motivo -->